import { PegasusPangareClient } from '@/helpers/pegasusPangareClient';

export default class UEEPegasusPangareRequestService {
  static async searchDexLists(
    searchTerm: string,
    userId: string
  ) {
    return await PegasusPangareClient.request({
      method: 'GET',
      requestURL: `/dex/lists/search?userId=${userId}&searchTerm=${encodeURIComponent(searchTerm)}`,
    });
  }
}
